<template>
  <div class="search-sidebar__content search__document">
<!--    <section class="search__document"> -->
    <h1 class="home__title">
      О документе
    </h1>

    <document-info 
      :card="currentDocumentInfo"
    />
<!--    </section> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DocumentInfo from '@@/document/DocumentSidebar/DocumentInfo';

export default {
  components: {
    DocumentInfo
  },

  computed: {
    ...mapGetters(['currentDocumentInfo'])
  }
};
</script>
